import React from 'react';
import styled from 'styled-components/macro';

import { fontDefault } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { FormattedTextField } from '@mirinae/lessons/components/lesson/elements/Text';
import { FormattedStaticPattern } from '@mirinae/lessons/components/lesson/elements/StaticPattern';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';

const CalloutBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: ${lessonsPalette.primary.white};
    border: 1px solid ${lessonsPalette.grey[5]};;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 15px;
`;

const Explanation = styled.div`
    font-family: ${fontDefault};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: ${lessonsPalette.grey[0]};
`;

const Examples = styled.div`
    display: flex;
    ${os.isOthers ? `
        flex-direction: row;
        justify-content: space-between;
        padding: 0px 30px;
    ` : `
        flex-direction: column;
        justify-content: center;
        padding-top: 10px;
    `}  
`;

const style = {
    koFontWeight: '700', koreanFontSize: '15px',
    enFontWeight: '500', englishFontSize: '15px',
};

const PatternCallout = ({ element }) => {

    return (
        <Element element={element}>
            <CalloutBox>
                <Explanation>
                    <FormattedTextField field={element.fieldsByName.explanation} />
                </Explanation>
                <Examples>
                    { element.fieldsByName.example1From && !element.fieldsByName.example1From.hidden && (
                        <FormattedStaticPattern base={element.fieldsByName.example1From} becomes={element.fieldsByName.example1To} style={style} />
                    )}
                    { element.fieldsByName.example2To && !element.fieldsByName.example2To.hidden && (
                        <FormattedStaticPattern base={element.fieldsByName.example2From} becomes={element.fieldsByName.example2To} style={style} />
                    )}
                </Examples>
            </CalloutBox>
        </Element>
    );
};

export default PatternCallout;
